var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHill2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.75 240.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.75,222.67v18.08s-141.75,0-141.75,0v-43.56c6.86-.75,13.71-.86,20.56-.29,13.71,1.15,27.42,5.03,41.13,10.29,13.71,5.25,27.42,11.88,34.28,15.19l45.78.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHill2);
export default __webpack_public_path__ + "static/media/hill2.c78a7b39d4e4b7557e525133ceb30692.svg";
export { ForwardRef as ReactComponent };